import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {TranslateService} from '@ngx-translate/core';
import {DxDataGridComponent} from "devextreme-angular";
import {ModelService} from "../../Services/model.service";
import {BackgroundJob} from "../../Model/Dto/BackgroundJob";
import {ValidateExportJob} from "../../Model/Dto/ValidateExportJob";
import {JobService} from "../../Services/job.service";
import {BackgroundJobEvent} from "../../Model/Dto/BackgroundJobEvent";
import {ExportParameter} from "../../Model/exportParameter/ExportParameter";
import {CatalogService} from "../../Services/CatalogManagement/catalog.service";
import {TemplateService} from "../../Services/template.service";
import {SignalrService} from "../../Services/signalr.service";
import {auditTime, filter, Subscription} from "rxjs";


@Component({
  selector: "jobDetail",
  templateUrl: "./jobDetail.component.html",
  styleUrls: ["../jobList.component.css"]
})
export class JobDetailComponent implements OnInit, OnDestroy {
  @Input() job: BackgroundJob;
  @Input() dataGrid: DxDataGridComponent;
  @Input() isVisible: boolean;
  @Input() rowExpaned: EventEmitter<any>;
  @Input() rowCollapsed: EventEmitter<any>;
  @Output() onInitialized = new EventEmitter();
  public events: BackgroundJobEvent[] = [];
  public timer: NodeJS.Timeout = null;
  public originialFileLink = "";
  public fileCaption = "";
  fileNotFound: boolean = false;
  firstViewInit = true;
  isPopupVisible: boolean;
  public exportParam: ExportParameter;
  catalogName: string = "";
  resultCatalogName: string = "";
  customerId: string = "";
  targetCustomerId: string = "";
  private jobDetailUpdateSub?: Subscription;
  private rowExpandedSub?: Subscription;
  private rowCollapsedSub?: Subscription;

  constructor(public modelService: ModelService,
              public translate: TranslateService,
              public jobService: JobService,
              public catalogService: CatalogService,
              public templateService: TemplateService,
              public signalRService: SignalrService) {
    this.isValidatable = this.isValidatable.bind(this);
    this.validateExport = this.validateExport.bind(this);
    this.getCatalogNameById = this.getCatalogNameById.bind(this);
    this.time = this.time.bind(this);
    this.getIconClass = this.getIconClass.bind(this);
    this.getOrignalFile = this.getOrignalFile.bind(this);
    this.getEventMessage = this.getEventMessage.bind(this);
    this.ngOnDestroy = this.ngOnDestroy.bind(this);
    this.ngOnInit = this.ngOnInit.bind(this);
    this.openCatalogById = this.openCatalogById.bind(this);
    this.hasExportParameter = this.hasExportParameter.bind(this);
    this.updateCatalogNamesIfNeeded = this.updateCatalogNamesIfNeeded.bind(this);
    this.updateEvents = this.updateEvents.bind(this);

    this.isPopupVisible = false;
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);

    this.rowExpandedSub?.unsubscribe();
    this.rowCollapsedSub?.unsubscribe();
    this.signalRService.removeJobDetailUpdate(this.job.id.toString());
    this.jobDetailUpdateSub?.unsubscribe();
    this.jobDetailUpdateSub = undefined;
  }

  async ngOnInit() {
    this.fileCaption = this.translate.instant("Datei");
    this.getOrignalFile();

    this.rowExpandedSub = this.rowExpaned
      .pipe(
        filter(x => x == this.job.id)
      )
      .subscribe(x => this.handleRowExpanded(x));

    this.rowCollapsedSub = this.rowCollapsed
      .pipe(
        filter(x => x == this.job.id)
      )
      .subscribe(x => this.handleRowCollapsed(x));

    await this.updateEvents();

    if (this.hasExportParameter(this.job)) {
      this.exportParam = Object.assign(new ExportParameter(), await this.jobService.getExportJobParameter(this.job.id, this.modelService.loginService.currentUser.customerId).toPromise());
      let i = 0;
    }


  }

  async handleRowExpanded(e: any) {
    await this.updateEvents();

    if (this.jobDetailUpdateSub && !this.jobDetailUpdateSub.closed) {
      return;
    }

    await this.signalRService.startJobDetailUpdateFeed(e.toString());
    this.jobDetailUpdateSub = this.signalRService.jobDetailUpdateSubject$.pipe(
      filter(e => e.jobId == this.job.id.toString()),
      auditTime(4000)
    ).subscribe(
      async e => {

        await this.updateEvents();
      }
    );
  }

  togglePopup(): void {
    this.isPopupVisible = !this.isPopupVisible;
  }

  async updateEvents() {
    if (!(this.isVisible && this.dataGrid.instance.isRowExpanded(this.job.id))) {
      return;
    }

    this.targetCustomerId = this.job.customerId;
    this.customerId = this.job.customerId;
    if (this.job.customerId != this.job.targetCustomerId) {
      this.targetCustomerId = this.job.targetCustomerId;
    }

    await this.updateCatalogNamesIfNeeded();
    let newEvents = await this.jobService.getJobEvents(this.job.id).toPromise();
    let originalCount = this.events.length;

    this.events = newEvents;

    if (this.events.length != originalCount) {
      this.onInitialized.emit();
    }

  }

  async updateCatalogNamesIfNeeded() {
    if (this.job.catalogId && (!this.catalogName || this.catalogName == "")) {
      let catalogName = await this.getCatalogNameById(this.job.catalogId, this.customerId);
      this.catalogName = catalogName;
    }

    if (this.job.resultCatalogId && (!this.resultCatalogName || this.resultCatalogName == "")) {
      let customerId = this.targetCustomerId ? this.targetCustomerId : this.customerId;
      let result = await this.getCatalogNameById(this.job.resultCatalogId, customerId);
      this.resultCatalogName = result ?? '';
    }
  }

  isValidatable(job: BackgroundJob): boolean {
    if (!job.resultFile)
      return false;

    return (job.typeText === 'Export' && job.state === 2 && job.resultFile.endsWith('.zip'));
  }

  hasExportParameter(job: BackgroundJob): boolean {
    return job.typeText === 'Export' || job.typeText === 'IntershopExport';
  }

  export() {
    this.exportParam.customerId = this.modelService.loginService.currentCustomer.id;
    this.exportParam.catalogId = this.job.catalogId;
    this.catalogService.export(this.exportParam, this.templateService.template);
    this.isPopupVisible = false;
  }

  validateExport(data: BackgroundJob) {
    let dto = new ValidateExportJob();
    dto.customerId = this.modelService.loginService.currentUser.customerId;
    dto.jobId = data.id;
    this.modelService.jobService.validateExportJob(dto)
      .subscribe(success => {
        if (success) {
          let i = 1;
        }
      });

  }

  async getCatalogNameById(id: string, customerId: string): Promise<string> {
    return await this.catalogService.getCatalogName(id, customerId);
  }

  time(started, ended) {
    // TODO: SAME in AdminComponent ==> move into a service!!
    var time = (Date.parse(ended) - Date.parse(started)) / 1000;
    if (time < 600) {
      let text = this.translate.instant("Sekunden");
      return Math.floor(time * 10) / 10 + " " + text;
    }
    let text = this.translate.instant("Minuten");
    time = time / 60;
    return Math.floor(time) + " " + text;
  }

  getIconClass(icon) {
    return JobService.getIconClass(icon);
  }

  getEventMessage(e: BackgroundJobEvent) {
    let result = "";
    if (e.parameter) {
      e.parameter = e.parameter.replace("\n", ""); //removing line breaks
      let param = JSON.parse(e.parameter);
      result = this.translate.instant(e.message, param);
    } else {
      result = this.translate.instant(e.message);
    }
    return result;
  }

  getOrignalFile() {
    if (this.job.filenameBlobUri != undefined) {
      this.originialFileLink = this.job.filenameBlobUri;
    }
    if (this.job.url) {
      this.fileCaption = "Url"
      this.originialFileLink = this.job.url;
    }
    if (this.job.filename && !this.job.url) {
      this.modelService.mediaService.getJobDataElement(this.modelService.loginService.currentUser.customerId, this.job.id.toString())
        .subscribe((result: any) => {
          if (result.items.length >= 1) {
            this.originialFileLink = result.items[0].blobUri;
            this.fileNotFound = false;
          } else
            this.fileNotFound = true;
        });
    }
  }

  getHelpMaillink(id: number) {
    return "mailto:support@nextpim.de?subject=Support%20f%C3%BCr%20Job%20" + id + "&body=Sehr%20geehrte%20Damen%20und%20Herren%2C%0A%0Aich%20ben%C3%B6tige%20Hilfe%20beim%20Job%20mit%20der%20ID%20" + id;
  }

  async openCatalogById(catalogId, isTarget: boolean = false) {

    var customerId = this.customerId;
    if (isTarget && this.targetCustomerId) {
      customerId = this.targetCustomerId;
    }

    await this.modelService.router.navigateByUrl('/', {skipLocationChange: true});
    //this.modelService.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    await this.modelService.router.navigate(["/catalog/" + customerId + "/" + catalogId + '/info']);
  }

  getSourceCatalogName() {

  }

  getTargetCatalogName() {

  }

  private handleRowCollapsed(e: any): void {
    this.signalRService.removeJobDetailUpdate(e.toString());
    this.jobDetailUpdateSub?.unsubscribe();
    this.jobDetailUpdateSub = undefined;
  }


}
